import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const DeliversEdit = props => (
  <Edit {...props} resource="delivers">
    <Form />
  </Edit>
);

DeliversEdit.propTypes = {};

export default DeliversEdit;
